import React from "react";
import DocumentTitle from "react-document-title";
import * as E from "./ElementsStyles";
import { ThemeContext } from "@fluentui/react-theme-provider";
import ElementService from "../../../services/ElementsService";
import { useHistory, useParams } from "react-router-dom";
import styles from "./indes.module.sass";
import { DefaultButton } from "@fluentui/react";
import ElementSignature from "../../../screen/Elements/ElementSignature";
import { ModalWithCancel } from "../../Modals/ModalWithCancel";
import TicketSupport from "../../TicketSupport/TicketSupport";
import { TicketSupportContainer } from "../../TicketSupport/TicketSupport.style";
import {
  MODAL_BODY_ERROR,
  MODAL_TITLE_ERROR,
  MODAL_TITLE_SUCCESS,
  PARTIAL_MODAL_BODY_SUCCESS,
  ScreenStepType,
} from "../../TicketSupport/TicketSupportConstants";
import TicketSupportService, {
  TicketSupportError,
  TicketSupportData,
} from "../../../services/TicketSupportService";

const ConvenienceTestElementsContract = () => {
  const { savingPlanId } = useParams<any>();
  const history = useHistory();
  const loadContractFirstTime = React.useRef<boolean>(false);
  const [contract, setContract] = React.useState<string>(
    "Cargando el contrato..."
  );
  const theme = React.useContext(ThemeContext);
  const [bottom, setBottom] = React.useState(false);

  // ticket soporte + modal
  const [showSupportForm, setShowSupportForm] = React.useState(false);
  const [showSupportResultModal, setShowSupportResultModal] =
    React.useState(false);
  const [modalSupportResultTitle, setModalSupportResultTitle] =
    React.useState("");
  const [modalSupportResultBody, setModalSupportResultBody] =
    React.useState("");
  const [ticketError, setTicketError] = React.useState<TicketSupportError>({
    status: false,
    message: "",
  });

  // -------------------------------------------------------------------
  // Ticket soporte
  // -------------------------------------------------------------------
  const handleSupportSend = async (ticketData: TicketSupportData) => {
    try {
      const response = await TicketSupportService.createNewSupportTicket(
        ticketData
      );

      if (response && response.Status === 200) {
        setModalSupportResultTitle(MODAL_TITLE_SUCCESS);
        setModalSupportResultBody(
          `Ticket con referencia: ${
            response.Id ?? "N/A"
          } ${PARTIAL_MODAL_BODY_SUCCESS}`
        );
      } else {
        setModalSupportResultTitle(MODAL_TITLE_ERROR);
        setModalSupportResultBody(MODAL_BODY_ERROR);
      }
    } catch (error) {
      console.error(`${MODAL_TITLE_ERROR} :`, error);
      setModalSupportResultTitle(MODAL_TITLE_ERROR);
      setModalSupportResultBody(MODAL_BODY_ERROR);
    } finally {
      setShowSupportResultModal(true);
    }
  };

  const handleScroll = (event: any) => {
    const bottom =
      event.target.scrollHeight - event.target.scrollTop <=
      event.target.clientHeight + 1;
    setBottom(bottom);
  };

  React.useEffect(() => {
    if (loadContractFirstTime.current === false) {
      ElementService.getElementContract()
        .then((response: string) => {
          if (response !== undefined) {
            loadContractFirstTime.current = true;
            setContract(response);
          } else {
            // contrato viene vacío
            setTicketError({
              status: false,
              message: "No se encontró el contrato.",
            });
            setContract(
              "No se ha podido cargar el contrato. Puedes ponerte en contacto con nosotros a través del formulario."
            );
            setShowSupportForm(true);
          }
        })
        .catch((error) => {
          setContract(
            "No se ha podido cargar el contrato. Puedes ponerte en contacto con nosotros a través del formulario."
          );
          setShowSupportForm(true);
          console.error("Error al obtener contrato:", error);
          setTicketError({
            status: false,
            message:
              "Error al obtener el contrato. [ERROR]: " + JSON.stringify(error),
          });
        });
    }
  }, []);

  return (
    <>
      {/* Soporte */}
      <TicketSupportContainer>
        <TicketSupport
          showSupportForm={showSupportForm}
          setShowSupportForm={setShowSupportForm}
          onSupportSend={handleSupportSend}
          component={"ConvenienceTestElementsContract"}
          screenName={ScreenStepType.LecturaContratoElements}
          ticketSupportError={ticketError}
        />
      </TicketSupportContainer>

      <DocumentTitle title="IronIA - Elements - Contrato">
        <React.Fragment>
          <E.ContractPanel
            theme={theme}
            onScroll={handleScroll}
            className={styles.content}
          >
            {contract !== undefined && (
              <div dangerouslySetInnerHTML={{ __html: contract }} />
            )}
          </E.ContractPanel>
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 ms-xl12 ms-xxl12 text-right">
              <DefaultButton
                className="button tiny-primary-button"
                id={styles.signButton}
                disabled={!bottom}
                onClick={() =>
                  history.push(`/elements-contract/confirm/${savingPlanId}`)
                }
              >
                Firmar
              </DefaultButton>
            </div>
          </div>
        </React.Fragment>
      </DocumentTitle>

      {/* Modal de confirmación */}
      <ModalWithCancel
        showModal={showSupportResultModal}
        setShowModal={setShowSupportResultModal}
        title={modalSupportResultTitle}
        body={modalSupportResultBody}
        onClose={() => setShowSupportResultModal(false)}
        btnSubmitText="Cerrar"
      />
    </>
  );
};

export default ConvenienceTestElementsContract;
